module.exports = __webpack_public_path__ + "img/silver-crown.9fa9ff17.svg";